import { Grid, Stack } from '@mantine/core'

import {
  Product as ProductType,
  Showcase as ShowcaseType,
  Site as SiteType,
  Store as StoreType
} from '@/types'

import ProductCard from './ProductCard'

interface Props {
  site?: SiteType
  store?: StoreType
  showcase?: ShowcaseType
  products: ProductType[]
}

export default function SinglePageDisplay({ site, store, showcase, products }: Props) {
  return (
    <Stack>
      {Array.isArray(products) && !!products?.length && (
        <Grid gutter="lg">
          {products.map((product: any) => (
            <Grid.Col key={product?.uid} span={12} xs={6} md={4} lg={12 / 5}>
              <ProductCard product={product} site={site} store={store} showcase={showcase} />
            </Grid.Col>
          ))}
        </Grid>
      )}
    </Stack>
  )
}
